// extracted by mini-css-extract-plugin
export default {"admin":"HeaderAdmin_admin__WINDt"};